export default function image(name) {
  if (import.meta.env.MODE === 'development') {
    return `${import.meta.env.VITE_CREDERE_EMBED_HOST}/src/assets/images/${name}`;
  }

  return new URL(`../images/${name}`, import.meta.url).href;
}
